<template>
  <path
    opacity="0.5"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1 2C1 0.89543 1.89543 0 3 0H11C12.1046 0 13 0.895431 13 2V7.10002C12.6769 7.03443 12.3425 7 12 7C10.3642 7 8.91184 7.78555 7.99963 9H3.5C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10H7.41604C7.14845 10.6125 7 11.2889 7 12C7 12.7111 7.14845 13.3875 7.41604 14H3C1.89543 14 1 13.1046 1 12V2ZM3.5 3C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H10.5C10.7761 4 11 3.77614 11 3.5C11 3.22386 10.7761 3 10.5 3H3.5ZM3 6.5C3 6.22386 3.22386 6 3.5 6H10.5C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7H3.5C3.22386 7 3 6.77614 3 6.5Z"
    fill="#3769D6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM14.1036 11.1036C14.2988 10.9083 14.2988 10.5917 14.1036 10.3964C13.9083 10.2012 13.5917 10.2012 13.3964 10.3964L11.25 12.5429L10.6036 11.8964C10.4083 11.7012 10.0917 11.7012 9.89645 11.8964C9.70118 12.0917 9.70118 12.4083 9.89645 12.6036L10.8964 13.6036C11.0917 13.7988 11.4083 13.7988 11.6036 13.6036L14.1036 11.1036Z"
    fill="#3769D6"
  />
</template>
